import React from "react";
import { wishlistSnackbarActions, WishlistSnackbarType } from "halifax";
import { useDispatch, useSelector } from "react-redux";
import {
  wishlistManagementModalActions,
  WishlistToggleHeart as WishlistToggleHeartComponent,
} from "halifax";
import { wishlistsApi } from "@capone/common";
import { BoxProps } from "@material-ui/core";
import { StayType } from "redmond/hotels-module/interfaces";
import { FAVORITES_REMOVE_ITEM, FavoritesItemProperties } from "redmond";
import { trackEvent } from "../../../../api/v0/analytics/trackEvent";

interface WishlistHeartToggleProps {
  listingId: string;
  listingImageUrl?: string;
  style?: BoxProps;
}

export const WishlistToggleHeart = ({
  listingId,
  listingImageUrl,
  style,
}: WishlistHeartToggleProps) => {
  const dispatch = useDispatch();

  const wishlistId = useSelector(
    wishlistsApi.endpoints.getAllWishlistItemsByUser.select()
  )?.data?.get(listingId);

  const onAddClick = () => {
    dispatch(
      wishlistManagementModalActions.openModal({
        listingId: listingId,
        listingImageUrl: listingImageUrl,
        stayType: StayType.Homes,
      })
    );
  };

  const onRemoveClick = () => {
    trackEvent({
      eventName: FAVORITES_REMOVE_ITEM,
      properties: {
        item_id: listingId,
        item_type: "vr",
      } as FavoritesItemProperties,
    });
    dispatch(
      wishlistSnackbarActions.showSnackbar({
        type: WishlistSnackbarType.REMOVE,
        wishlistId: wishlistId,
        listingId: listingId,
        stayType: StayType.Homes,
      })
    );
  };

  return (
    <WishlistToggleHeartComponent
      isWishlisted={Boolean(wishlistId)}
      style={style}
      listingId={listingId}
      stayType={StayType.Homes}
      onAddClick={onAddClick}
      onRemoveClick={onRemoveClick}
    />
  );
};
